'use strict';

angular.module('amexReconciliationApp')
  .component('transactionListActions', {
    templateUrl: 'scripts/views/directives/transaction-list-actions.html',
    bindings: {
      displayBta: '&',
      displayPo: '&',
      approvalSettingOnForRole: '&'
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionListActions.js
// module id = 490
// module chunks = 0